module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择产品"
    },
    model: {
      value: (_vm.pdata.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_id", $$v)
      },
      expression: "pdata.issued_app_id"
    }
  }, _vm._l((_vm.apps), function(item) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(31)
      }
    }
  }, [_vm._v("最近31天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "selfTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "default-sort": {
        prop: 'visit_uv_out',
        order: 'descending'
      },
      "show-summary": "",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    staticClass: "expandd",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "",
            "align": "center",
            "width": "48px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_out",
            "show-overflow-tooltip": "",
            "label": "换出日活",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_in",
            "show-overflow-tooltip": "",
            "label": "换入日活",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "diff",
            "show-overflow-tooltip": "",
            "label": "顺逆差",
            "align": "center"
          }
        })], 1)]
      }
    }], null, false, 1423129300)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "show-overflow-tooltip": "",
      "label": "流量主游戏",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_out",
      "show-overflow-tooltip": "",
      "label": "换出日活",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_out - 0) - (b.visit_uv_out - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_in",
      "show-overflow-tooltip": "",
      "label": "换入日活",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_in - 0) - (b.visit_uv_in - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "diff",
      "show-overflow-tooltip": "",
      "label": "顺逆差",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.diff - 0) - (b.diff - 0)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑实际换量",
      "visible": _vm.editDialog,
      "width": "550px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.chooseEditProduct
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "换出日活"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_out),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_out", $$v)
      },
      expression: "chooseEditProduct.visit_uv_out"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "换入日活"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_in),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_in", $$v)
      },
      expression: "chooseEditProduct.visit_uv_in"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editChooseProduct($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65fcb2b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/exchange/exchangeDailyDetail.vue
// module id = 1139
// module chunks = 2